import {defineMessages} from 'react-intl';

export default defineMessages({
	generalError: {
		id: 'common.error.general',
		defaultMessage: 'Oops! Something went wrong.'
	}
});